import Conf from 'conf';
import { NGM_DEV_CLI_NAME } from '../constants';

const get = () => new Conf({ projectName: NGM_DEV_CLI_NAME });

export { get };
